import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SpinnerComponent } from '@app/shared/ui/simple-components/spinner/spinner.component';
import { SvgSourceModule } from '@app/shared/ui/svg-source/svg-source.module';

@NgModule({
  imports: [CommonModule, SvgSourceModule],
  declarations: [SpinnerComponent],
  exports: [SpinnerComponent],
})
export class SpinnerModule {}
